import { isLoggedInUserThinkingphones } from "lib/user-session"

export function useIsOperatorTenant(): boolean {
  return isLoggedInUserThinkingphones()
}
